// extracted by mini-css-extract-plugin
module.exports = {"benefit-container":"BenefitItem_benefit-container__3L9s5","benefit-item":"BenefitItem_benefit-item__dpBsm"};